const FOCUSABLE = [
  "a[href]",
  "button:not([disabled])",
  "input:not([disabled]):not([type='hidden'])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "[tabindex]:not([tabindex='-1'])",
].join(",");

let isOpen = false;
let returnFocusTo = null;
let suggestionsSlider = null;

const getDialog = () =>
  document.querySelector("#yith-wacp-popup .yith-wacp-wrapper");

const isVisible = (element) =>
  element.isConnected && element.getClientRects().length > 0;

const closeQuickView = () => {
  if (!document.documentElement.classList.contains("yith-quick-view-is-open")) {
    return;
  }

  const close = document.querySelector(".yith-quick-view .yith-quick-view-close");

  if (close) {
    jQuery(close).trigger("click");
  }
};

const focusDialog = () => {
  const dialog = getDialog();

  if (dialog && !dialog.contains(document.activeElement)) {
    dialog.focus({ preventScroll: true });
  }
};

const mountSuggestionsSlider = () => {
  if (suggestionsSlider) {
    suggestionsSlider.destroy();
    suggestionsSlider = null;
  }

  const root = document.querySelector("#yith-wacp-popup .smartwood-wacp-slider");

  if (!root || typeof Splide === "undefined") {
    return;
  }

  suggestionsSlider = new Splide(root, {
    type: "slide",
    perPage: 3,
    perMove: 1,
    fixedWidth: "calc((100% - 36px) / 3.3)",
    omitEnd: true,
    drag: true,
    rewind: true,
    arrows: false,
    pagination: true,
    gap: "12px",
    padding: "32px",
    breakpoints: {
      575: {
        perPage: 2,
        fixedWidth: "calc((100% - 24px) / 2.25)",
        padding: "16px",
      },
    },
  });

  suggestionsSlider.mount();
};

const trapTab = (event) => {
  if (!isOpen || event.key !== "Tab") {
    return;
  }

  const dialog = getDialog();

  if (!dialog) {
    return;
  }

  const focusable = [...dialog.querySelectorAll(FOCUSABLE)].filter(isVisible);

  if (!focusable.length) {
    event.preventDefault();
    dialog.focus({ preventScroll: true });
    return;
  }

  const first = focusable[0];
  const last = focusable[focusable.length - 1];
  const active = document.activeElement;
  const outside = !dialog.contains(active);

  if (event.shiftKey && (active === first || active === dialog || outside)) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && (active === last || outside)) {
    event.preventDefault();
    first.focus();
  }
};

export const setupAddedToCartPopup = () => {
  if (!document.getElementById("yith-wacp-popup") || typeof jQuery === "undefined") {
    return;
  }

  jQuery(document).on("yith_wacp_popup_before_opening", () => {
    returnFocusTo = document.activeElement;
    closeQuickView();
  });

  jQuery(document).on("yith_wacp_popup_after_opening", () => {
    isOpen = true;
    mountSuggestionsSlider();
    requestAnimationFrame(focusDialog);
  });

  jQuery(document).on("yith_wacp_popup_changed", () => {
    if (isOpen) {
      mountSuggestionsSlider();
      focusDialog();
    }
  });

  jQuery(document).on("yith_wacp_popup_after_closing", () => {
    if (!isOpen) {
      return;
    }

    isOpen = false;

    if (returnFocusTo && returnFocusTo !== document.body && isVisible(returnFocusTo)) {
      returnFocusTo.focus({ preventScroll: true });
    }

    returnFocusTo = null;
  });

  jQuery("#yith-wacp-popup").on("click", ".yith-wcqv-button", () => {
    returnFocusTo = null;
    jQuery("#yith-wacp-popup .yith-wacp-close").trigger("click");
  });

  document.addEventListener("keydown", trapTab);
};
